import React from 'react';
import Skeleton from 'components/general/Skeleton/Skeleton';

const PaginationSkeleton = () => (
  <div className="pagination">
    <div className="pagination__label">
      <Skeleton width={[100, 120]} />
    </div>
    <div className="pagination__nav">
      <div className="pagination__nav-item">
        <Skeleton types={['box']} />
      </div>
      <div className="pagination__nav-item">
        <Skeleton types={['box']} />
      </div>
    </div>
  </div>
);

export default PaginationSkeleton;
